import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import styles from "./style.module.scss";
import creditzActions from "../../redux/creditz/actions";
import profileActions from "../../redux/profile/actions";
import LeftSideComponent from "./leftSideComponent";
import CreditzList from "./creditzList";
import CreateNewCreditz from "./newCreditz";
import EditCreditz from "./editCreditz";
import CreditzProfile from "./creditzProfile";
import { makeStyles } from "@material-ui/core/styles";
import AddButtonComponent from "./addButtonComponent"

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    top: "50px",
    position: "relative",
    left: "-50px",
  },
  cover: {
    width: 73,
    height: 73,
    borderRadius: "50%",
  },
}));

const Profile = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    loading,
    newCreditzCreated,
    newCreditz,
    additionalRoles,
    currentUser,
    pending = [],
    viewCreditzProfile = {},
  } = useSelector((state) => ({
    loading: state.creditz.loading,
    newCreditzCreated: state.creditz.newCreditzCreated,
    newCreditz: state.creditz.newCreditz,
    additionalRoles: state.creditz.additionalRoles,
    currentUser: state.profile.currentUser,
    pending: state.creditz.creditz,
    viewCreditzProfile: state.creditz.viewCreditzProfile,
  }));
  const [selected, setSelected] = useState("CreditzList");
  const [values, setValues] = useState({});

  useEffect(() => {
    dispatch({
      type: profileActions.GET_USER_MUSICS,
    });
  }, []);

  useEffect(() => {
    if (newCreditzCreated) {
      setSelected("EditCreditz");
      setValues(newCreditz);
      dispatch({
        type: creditzActions.SET_STATE,
        payload: { newCreditzCreated: false },
      });
    }
  }, [newCreditzCreated]);

  useEffect(() => {
    if (viewCreditzProfile.id) {
      setSelected("CreditzProfile");
      setValues({ post: viewCreditzProfile });
    }
  }, [viewCreditzProfile.id]);

  useEffect(() => {
    if (selected !== "CreditzProfile") {
      dispatch({
        type: creditzActions.SET_STATE,
        payload: { viewCreditzProfile: {} },
      });
    }
  }, [selected]);

  useEffect(() => {
    return () => {
      dispatch({
        type: creditzActions.SET_STATE,
        payload: { viewCreditzProfile: {} },
      });
    };
  },[]);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <div className={styles.mainComponent}>
        <div className={styles.mainContent}>
          <div className={styles.leftContainer}>
            <LeftSideComponent
              showProfile={selected === "CreditzProfile"}
              history={history}
              currentUser={currentUser}
              pending={
                pending.filter((c) => c.notification.status === 1).length
              }
            />
          </div>
          <div className={styles.rightContainer}>
            {selected === "CreditzList" && (
              <CreditzList
                setAddNewCreditz={setSelected}
                setView={() => setSelected("CreditzProfile")}
                setValues={setValues}
              />
            )}
            {selected === "CreateNewCreditz" && (
              <CreateNewCreditz
                values={values}
                additionalRoles1={additionalRoles}
                setValues={setValues}
                setView={() => setSelected("EditCreditz")}
              />
            )}
            {selected === "EditCreditz" && (
              <EditCreditz
                values={newCreditz}
                setView={() => setSelected("CreateNewCreditz")}
                additionalRoles={additionalRoles}
              />
            )}
            {selected === "CreditzProfile" && (
              <CreditzProfile values={values} />
            )}
          </div>
          {selected === "CreditzList" ? <AddButtonComponent setAddNewCreditz={"setAddNewCreditz"} /> :
          <div style={{width: 247}} />}
        </div>
      </div>
    </>
  );
};

Profile.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Profile);
